import CityPageTemplate from "../city-template/CityPageTemplate";
import { breckenridgeConfig } from "./data";

export default function BreckenridgePage() {
  return <CityPageTemplate config={breckenridgeConfig} />;
}